
<template>
  <v-card>
    <v-card-text>
      <v-container fluid>
        <v-card outlined class="seccion">
          <v-card-title> Filtros guardados</v-card-title>
          <v-row align="center">
            <v-col cols="auto" id="plantillas">
              <v-autocomplete
                v-model="listadoAcciones.plantillaSeleccionada"
                :items="listadoAcciones.plantillasFiltros"
                @change="
                  $store.commit(
                    'listadoAcciones/UPDATE_PLANTILLA_SELECCIONADA',
                    listadoAcciones.plantillaSeleccionada
                  )
                "
                chips
                color="blue-grey lighten-2"
                label="Filtros..."
                return-object
                clearable
                item-text="nombre"
                item-value="id"
                :loading="listadoAcciones.loadingFiltrosListadoAcciones"
                :disabled="listadoAcciones.loadingFiltrosListadoAcciones"
              >
                <template v-slot:selection="data">
                  <v-chip color="info" outlined small>
                    {{ data.item.nombre }}
                  </v-chip>
                </template>

                <template v-slot:item="{ item }">
                  <template v-if="isObject(item)">
                    <v-list-item-content>{{ item }}</v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn
                        icon
                        @click.stop="
                          dialogConfirmEliminarPlantilla = true;
                          itemEliminar = item.id;
                        "
                      >
                        <v-icon color="grey lighten-1">mdi-delete</v-icon>
                      </v-btn>
                      <BaseConfirmDelete
                        v-model="dialogConfirmEliminarPlantilla"
                        @confirm="eliminarFiltro($event)"
                        message="Vas a eliminar este filtro. ¿Estás seguro?"
                        confirm-text="Eliminar"
                        :item="itemEliminar"
                      />
                    </v-list-item-action>
                  </template>
                </template>
              </v-autocomplete>
              <v-dialog max-width="50em" v-model="dialogGuardarPlantilla">
                <dialog-guardar-filtros
                  @close="dialogGuardarPlantilla = false"
                />
              </v-dialog>
            </v-col>
            <!-- <v-col cols="auto" id="plantilla">
              <v-btn
                color="primary lighten-1"
                @click=""
              >
                Guardar como plantilla
              </v-btn>
            </v-col> -->
          </v-row>
        </v-card>
        <v-card outlined class="seccion">
          <v-card-title>Filtros generales </v-card-title>
          <v-row align="end">
            <v-col cols="auto" id="generales">
              <date-picker
                ref="datePickerFechaIni"
                :date="listadoAcciones.filtros.fechaInicio"
                title="Fecha inicio"
                v-bind:conIcono="true"
                @actualizarFecha="actualizarFechaInicio"
              ></date-picker>
            </v-col>
            <v-col cols="auto" id="generales">
              <date-picker
                ref="datePickerFechaFin"
                v-bind:date="listadoAcciones.filtros.fechaFin"
                title="Fecha Fin"
                v-bind:conIcono="true"
                @actualizarFecha="actualizarFechaFin"
              ></date-picker>
            </v-col>
            <v-col cols="auto" id="generales">
              <v-autocomplete
                v-model="listadoAcciones.filtros.clienteSeleccionado"
                @change="
                  actualizarFiltro(
                    'clienteSeleccionado',
                    listadoAcciones.filtros.clienteSeleccionado
                  )
                "
                :items="clientes"
                chips
                :loading="loadingClientes"
                :disabled="loadingClientes"
                color="blue-grey lighten-2"
                label="Cliente"
                return-object
                clearable
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="auto" id="generales">
              <v-autocomplete
                v-model="listadoAcciones.filtros.tecnicoSeleccionado"
                :items="tecnicos"
                chips
                item-text="nombre"
                label="Tecnico"
                :loading="loadingUsuarios"
                :disabled="loadingUsuarios"
                color="blue-grey lighten-2"
                return-object
                clearable
                @change="
                  actualizarFiltro(
                    'tecnicoSeleccionado',
                    listadoAcciones.filtros.tecnicoSeleccionado
                  )
                "
              >
                <template v-slot:selection="data">
                  <v-chip v-bind="data.attrs" :input-value="data.selected">
                    <v-avatar left :color="data.item.color">
                      <span class="white--text">{{ data.item.avatar }}</span>
                    </v-avatar>
                    {{ data.item.nombre }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-item-avatar :color="data.item.color">
                      <span class="white--text">{{ data.item.avatar }}</span>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        data.item.nombre
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        data.item.apellidos
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row id="generales">
            <v-col class="py-0">
              <v-switch
                :input-value="listadoAcciones.filtros.bloqueadas"
                @change="
                  actualizarFiltro(
                    'bloqueadas',
                    !listadoAcciones.filtros.bloqueadas
                  )
                "
                label="Mostrar acciones cerradas"
              >
              </v-switch>
            </v-col>
          </v-row>
        </v-card>

        <v-card outlined class="seccion">
          <v-card-title class="titulo-seccion"
            >Filtros de acciones
            <v-switch
              :input-value="listadoAcciones.filtros.mostrarAcciones"
              @change="
                actualizarFiltro(
                  'mostrarAcciones',
                  !listadoAcciones.filtros.mostrarAcciones
                )
              "
              label="Mostrar acciones"
              id="switch-with-label"
            ></v-switch>
          </v-card-title>

          <v-expand-transition>
            <v-row
              align="end"
              id="acciones"
              v-show="listadoAcciones.filtros.mostrarAcciones"
            >
              <v-col cols="auto">
                <v-autocomplete
                  v-model="listadoAcciones.filtros.filtroEstadoParte"
                  :items="estadosParte"
                  :loading="loadingEstados"
                  :disabled="loadingEstados"
                  @change="
                    actualizarFiltro(
                      'filtroEstadoParte',
                      listadoAcciones.filtros.filtroEstadoParte
                    )
                  "
                  chips
                  multiple
                  label="Estado parte"
                  return-object
                  clearable
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :color="data.item.color"
                      outlined
                      small
                      close
                      @click:close="
                        removeFilter('filtroEstadoParte', data.item)
                      "
                    >
                      {{ data.item.text }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="auto">
                <v-autocomplete
                  v-model="listadoAcciones.filtros.filtroTipoAccion"
                  :items="tiposAccion"
                  :loading="loadingContratos"
                  :disabled="loadingContratos"
                  @change="
                    actualizarFiltro(
                      'filtroTipoAccion',
                      listadoAcciones.filtros.filtroTipoAccion
                    )
                  "
                  chips
                  multiple
                  label="Tipos de accion"
                  return-object
                  clearable
                >
                  <template v-slot:selection="data">
                    <v-chip
                      color="info"
                      outlined
                      small
                      close
                      @click:close="removeFilter('filtroTipoAccion', data.item)"
                    >
                      {{ data.item.text }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-expand-transition>
        </v-card>
        <v-card outlined class="seccion">
          <v-card-title class="titulo-seccion"
            >Filtros de contratos
            <v-switch
              :input-value="listadoAcciones.filtros.mostrarPacks"
              @change="
                actualizarFiltro(
                  'mostrarPacks',
                  !listadoAcciones.filtros.mostrarPacks
                )
              "
              id="switch-with-label"
              label="Mostrar contratos"
            ></v-switch>
          </v-card-title>
          <v-expand-transition>
            <v-row
              align="end"
              id="acciones"
              v-show="listadoAcciones.filtros.mostrarPacks"
            >
              <v-col cols="auto">
                <v-autocomplete
                  v-model="listadoAcciones.filtros.filtroTipoPack"
                  :items="contratosDisponibles"
                  :loading="loadingContratos"
                  :disabled="loadingContratos"
                  @change="
                    actualizarFiltro(
                      'filtroTipoPack',
                      listadoAcciones.filtros.filtroTipoPack
                    )
                  "
                  chips
                  multiple
                  label="Tipos de packs y tramos"
                  return-object
                  clearable
                >
                  <template v-slot:selection="data">
                    <v-chip
                      color="info"
                      outlined
                      small
                      close
                      @click:close="removeFilter('filtroTipoPack', data.item)"
                    >
                      {{ data.item.text }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-expand-transition>
        </v-card>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-col>
        <v-row>
          <v-btn
            color="error"
            text
            @click="$store.commit('listadoAcciones/RESET_FILTERS')"
            >Reiniciar filtros</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialogGuardarPlantilla = true"
          >
            Guardar filtro
          </v-btn>

          <v-spacer></v-spacer>
          <v-btn text @click="$store.commit('listadoAcciones/TOGGLE_DIALOG')"
            >Cerrar</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="$store.commit('listadoAcciones/TOGGLE_DIALOG', true)"
          >
            Aplicar
          </v-btn>
        </v-row>
      </v-col>
    </v-card-actions>
  </v-card>
</template>
<script>
import axios from "axios";
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
import Datepicker from "../../components/utils/Datepicker";
import DialogGuardarFiltros from "./DialogGuardarFiltros";
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      dialogGuardarPlantilla: false,
      dialogConfirmEliminarPlantilla: false,
      itemEliminar: null,
    };
  },
  components: {
    "date-picker": Datepicker,
    "dialog-guardar-filtros": DialogGuardarFiltros,
  },
  computed: {
    ...mapState(["listadoAcciones"]),
    ...mapGetters({
      clientes: "clientesDisponibles",
      loadingClientes: "loadingClientes",
      tecnicos: "usuarios/tecnicos",
      loadingUsuarios: "usuarios/loadingUsuarios",
      contratosDisponibles: "contratos/contratosDisponibles",
      tiposAccion: "contratos/tiposAccion",
      loadingContratos: "contratos/loadingContratos",
      estadosParte: "partes/estadosParte",
      loadingEstados: "partes/loadingEstados",
    }),
  },
  methods: {
    isObject(item) {
      typeof item === "object";
    },
    eliminarFiltro(id) {
      this.$store.dispatch("listadoAcciones/deleteFiltroListadoAcciones", id);
    },
    aplicarPlantilla() {
      this.$store.dispatch("listadoAcciones/aplicarPlantilla");
    },
    actualizarFiltro(filtro, value) {
      this.$store.commit("listadoAcciones/UPDATE_FILTRO", {
        filtro,
        value,
      });
    },
    actualizarFechaInicio(val) {
      this.actualizarFiltro("fechaInicio", val);
    },
    actualizarFechaFin(val) {
      this.actualizarFiltro("fechaFin", val);
    },
    removeFilter(filtro, value) {
      //REVISAR!
      this.$store.commit("listadoAcciones/REMOVE_FILTRO", {
        filtro,
        value,
      });
    },
  },
  created() {
    if (!this.clientes.length) {
      this.$store.dispatch("getClientesDisponibles");
    }
    if (!this.tecnicos.length) {
      this.$store.dispatch("usuarios/getUsuarios");
    }
    if (!this.contratosDisponibles.length) {
      this.$store.dispatch("contratos/getContratosDisponibles");
    }
    if (!this.estadosParte.length) {
      this.$store.dispatch("partes/getEstadosParte");
    }
    this.$store.dispatch("listadoAcciones/getFiltrosListadoAcciones");
  },
};
</script>
<style>
#plantillas {
  margin-left: 0.75em;
  max-width: 40em;
}
#generales {
  max-width: 25em;
  margin-left: 0.75em;
}
#acciones {
  max-width: 40em;
  margin-left: 0.75em;
}
.seccion {
  margin-bottom: 0.2em;
}
.titulo-seccion {
  gap: 0.5em;
}
label[for="switch-with-label"] {
  /* visibility: hidden; */
  display: none !important;
}

.v-input:hover label[for="switch-with-label"] {
  /* visibility: visible; */
  display: block !important;
}
</style>